import { render } from "./NavBar.vue?vue&type=template&id=2d73c64e"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\mercado-web-1.2.41 - mercado-web-1.2.50\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__